import { ForwardRefExoticComponent, RefAttributes, SVGProps } from "react";
import {
  AtSymbolIcon,
  BanknotesIcon,
  BuildingOfficeIcon,
  BuildingStorefrontIcon,
  ComputerDesktopIcon,
  CubeIcon,
  DevicePhoneMobileIcon,
  DocumentIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  FilmIcon,
  FlagIcon,
  GlobeAmericasIcon,
  InboxStackIcon,
  ListBulletIcon,
  MapIcon,
  NewspaperIcon,
  PhotoIcon,
  PowerIcon,
  PrinterIcon,
  RocketLaunchIcon,
  ShoppingBagIcon,
  Squares2X2Icon,
  TrophyIcon,
} from "@heroicons/react/24/outline";
import { TvIcon } from "@heroicons/react/24/solid";

interface UseCaseMapping {
  [key: string]: {
    category: string;
    color: string;
    icon: ForwardRefExoticComponent<Omit<SVGProps<SVGSVGElement>, "ref"> & RefAttributes<SVGSVGElement>>;
  };
}

/*
 * useCaseMapping
 * maps use cases to categories, colors, and icons
 */
export const useCaseMapping: UseCaseMapping = {
  Websites: {
    category: "UX/CRO",
    color: "primary",
    icon: GlobeAmericasIcon,
  },
  "Video Games": {
    category: "UX/CRO",
    color: "primary",
    icon: RocketLaunchIcon,
  },
  "Smart TV": {
    category: "UX/CRO",
    color: "primary",
    icon: TvIcon,
  },
  Apps: {
    category: "UX/CRO",
    color: "primary",
    icon: Squares2X2Icon,
  },
  Display: {
    category: "Advertising",
    color: "[#9747FF]",
    icon: ComputerDesktopIcon,
  },
  OOH: {
    category: "Advertising",
    color: "[#9747FF]",
    icon: PhotoIcon,
  },
  Print: {
    category: "Advertising",
    color: "[#9747FF]",
    icon: PrinterIcon,
  },
  Social: {
    category: "Advertising",
    color: "[#9747FF]",
    icon: DevicePhoneMobileIcon,
  },
  "In-Game": {
    category: "Advertising",
    color: "[#9747FF]",
    icon: PowerIcon,
  },
  "TV/VOD": {
    category: "Advertising",
    color: "[#9747FF]",
    icon: FilmIcon,
  },
  "Email Templates": {
    category: "Email Marketing",
    color: "warning",
    icon: AtSymbolIcon,
  },
  Letters: {
    category: "Direct Mail",
    color: "success",
    icon: EnvelopeIcon,
  },
  Newsletters: {
    category: "Direct Mail",
    color: "success",
    icon: NewspaperIcon,
  },
  Brochures: {
    category: "Direct Mail",
    color: "success",
    icon: MapIcon,
  },
  Flyers: {
    category: "Direct Mail",
    color: "success",
    icon: DocumentTextIcon,
  },
  General: {
    category: "Custom",
    color: "warning",
    icon: ComputerDesktopIcon,
  },
  "A+ Content": {
    category: "E-Commerce",
    color: "warning",
    icon: ShoppingBagIcon,
  },
  "Hero Images": {
    category: "E-Commerce",
    color: "warning",
    icon: TrophyIcon,
  },
  "B+ Content": {
    category: "E-Commerce",
    color: "warning",
    icon: ShoppingBagIcon,
  },
  "Promotional Materials": {
    category: "In-Store",
    color: "[#19D3C8]",
    icon: FlagIcon,
  },
  "Visual Merchandising": {
    category: "In-Store",
    color: "[#19D3C8]",
    icon: BuildingStorefrontIcon,
  },
  Packaging: {
    category: "In-Store",
    color: "[#19D3C8]",
    icon: CubeIcon,
  },
  Other: {
    category: "Custom",
    color: "accent",
    icon: DocumentIcon,
  },
  // Scene-specific use cases (In-store)
  POS: {
    category: "In-store",
    color: "[#19D3C8]",
    icon: BanknotesIcon,
  },
  Shelf: {
    category: "In-store",
    color: "[#19D3C8]",
    icon: InboxStackIcon,
  },
  Aisle: {
    category: "In-store",
    color: "[#19D3C8]",
    icon: MapIcon,
  },
  "Window display": {
    category: "In-store",
    color: "[#19D3C8]",
    icon: BuildingOfficeIcon,
  },
  // Scene-specific use cases (E-commerce)
  SERP: {
    category: "E-commerce",
    color: "warning",
    icon: ListBulletIcon,
  },
  PDP: {
    category: "E-commerce",
    color: "warning",
    icon: CubeIcon,
  },
  Store: {
    category: "E-commerce",
    color: "warning",
    icon: ShoppingBagIcon,
  },
  // Scene-specific use cases (Social Networks)
  "Social Feed": {
    category: "Social Networks",
    color: "[#9747FF]",
    icon: DevicePhoneMobileIcon,
  },
  // Scene-specific use cases (Website)
  Website: {
    category: "Website",
    color: "primary",
    icon: GlobeAmericasIcon,
  },
};
